import isServer from "@utils/is-server";

export function calculateNextImageSizesByDeviceAndGrid(typeOfGrid, device) {
  if (isServer()) return "320px";

  switch(device) {
    case "mobile":
    // device width : 0 to 991px
      switch(typeOfGrid) {
      // 1 column
        case "big-pictures":
          // < 352px : 320px,
          // 352px to 416px : 384px,
          // 417px to 480px : 448px,
          // 481px to 767px : 512px,
          // 768px to 991px : 704px          
          return "(max-width: 352px) 320px,(max-width: 416px) 384px, (max-width: 480px) 448px, (max-width: 767px) 512px, (max-width: 991px) 704px";
        
        // 2 columns
        case "small-pictures":
          // < 439px : 192px,
          // 440px to 767px : 256px,
          // 768px to 991px : 384px
          return "(max-width: 439px) 192px, (max-width: 767px) 256px, (max-width: 991px) 384px";

        default:
          return "448px";
      }
    
    case "desktop":
    // device width : >= 992px
      switch(typeOfGrid) {
        // 2 columns
        case "big-pictures":
          // 992 to 1199px : 512px,
          // 1200px to 1399px : 576px,
          // >= 1400px : 640px
          return "(max-width: 1199px) 512px, (max-width: 1399px) 576px, 640px";
  
        // 4 columns
        case "small-pictures":
          // 992px to 1199px : 256px,
          // 1200px to 1399px : 320px,
          // >= 1400px : 320px
          return "(max-width: 1199px) 256px, 320px";
  
        default:
          return "448px";
      }
    
    default:
      return "448px";
  }
}